import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30e96e25"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "activations-container"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "header-filters" }
const _hoisted_4 = { class: "default-filters" }
const _hoisted_5 = { class: "header-filters-search" }
const _hoisted_6 = { class: "p-input-icon-left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_8 = { class: "activations-actions" }
const _hoisted_9 = {
  key: 0,
  class: "selected-items-actions"
}
const _hoisted_10 = {
  key: 1,
  class: "admin-actions"
}
const _hoisted_11 = { class: "defaults" }
const _hoisted_12 = {
  key: 2,
  class: "admin-actions"
}
const _hoisted_13 = { class: "defaults" }
const _hoisted_14 = {
  key: 0,
  style: {"padding-top":"12px"}
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "lm-table-row-actions" }
const _hoisted_18 = {
  key: 1,
  class: "activations-container"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "header-filters" }
const _hoisted_21 = { class: "default-filters" }
const _hoisted_22 = { class: "header-filters-search" }
const _hoisted_23 = { class: "p-input-icon-left" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_25 = { class: "activations-actions" }
const _hoisted_26 = {
  key: 0,
  class: "selected-items-actions"
}
const _hoisted_27 = {
  key: 1,
  class: "admin-actions"
}
const _hoisted_28 = { class: "defaults" }
const _hoisted_29 = {
  key: 2,
  class: "admin-actions"
}
const _hoisted_30 = { class: "defaults" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "lm-table-row-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_Column = _resolveComponent("Column")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.accountStore.isAdmin || _ctx.accountStore.isEmployee)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.showModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_DataTable, {
                class: "activations-datatable",
                scrollHeight: "flex",
                stripedRows: "",
                dataKey: "autoId",
                selectionMode: "single",
                currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                rowsPerPageOptions: [10, 25, 50, 100],
                selection: _ctx.selectedActivation,
                "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedActivation) = $event)),
                scrollable: true,
                value: _ctx.items,
                paginator: true,
                rows: _ctx.rows,
                totalRecords: _ctx.totalRecords,
                filters: _ctx.filters,
                "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters) = $event)),
                loading: _ctx.loading,
                globalFilterFields: _ctx.globalFilter,
                filterDisplay: "row"
              }, _createSlots({
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_Dropdown, {
                          style: {"width":"14em"},
                          modelValue: _ctx.selectedAccount,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAccount) = $event)),
                          optionLabel: "name",
                          optionValue: "id",
                          placeholder: "Select an Account",
                          options: _ctx.selectableAccounts,
                          showClear: true,
                          filter: true,
                          onChange: _ctx.processAccountFilterUpdate
                        }, null, 8, ["modelValue", "options", "onChange"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_Dropdown, {
                          style: {"width":"14em","margin-left":"10px"},
                          modelValue: _ctx.selectedLicense,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedLicense) = $event)),
                          placeholder: "Select a License",
                          optionValue: "id",
                          optionLabel: _ctx.getActivationLabel,
                          options: _ctx.selectableLicenses,
                          filter: true,
                          onChange: _ctx.processLicenseFilterUpdate
                        }, null, 8, ["modelValue", "optionLabel", "options", "onChange"])
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, [
                          _hoisted_7,
                          _createVNode(_component_InputText, {
                            modelValue: _ctx.filters['global'].value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
                            placeholder: "Keyword Search"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      (_ctx.selectedActivation && _ctx.selectedActivation.autoId)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", null, [
                              _createVNode(_component_Button, {
                                label: "Delete Activation",
                                class: "p-button-danger p-button-outlined",
                                onClick: _ctx.deleteLicenseActivation
                              }, null, 8, ["onClick"]),
                              _createVNode(_component_ConfirmPopup)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.totalRecords > 0 && !_ctx.accountStore.isCustomer)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_Button, {
                                label: "Export",
                                class: "p-button-secondary p-button-outlined",
                                onClick: _ctx.exportLicenseActivations
                              }, null, 8, ["onClick"])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_Button, {
                                label: "Export",
                                class: "p-button-secondary p-button-outlined",
                                onClick: _ctx.exportClientLicenseActivations
                              }, null, 8, ["onClick"])
                            ])
                          ]))
                    ])
                  ]),
                  (_ctx.selectedAccountDto)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("h5", null, " Account: " + _toDisplayString(_ctx.selectedAccountDto.name) + " " + _toDisplayString(_ctx.selectedAccountDto.surname) + " " + _toDisplayString(_ctx.selectedAccountDto.company ? '(' + _ctx.selectedAccountDto.company + ')' : ''), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                loading: _withCtx(() => [
                  _createTextVNode("Loading licenses. Please wait.")
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    header: "Actions",
                    headerStyle: "padding-left: 18px;",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives((_openBlock(), _createElementBlock("div", null, [
                          _createVNode(_component_Button, {
                            type: "button",
                            icon: "pi pi-trash",
                            onClick: ($event: any) => (_ctx.deleteActivationFromGrid(data, $event)),
                            class: "p-button-rounded p-button-outlined p-button-danger"
                          }, null, 8, ["onClick"])
                        ])), [
                          [_directive_tooltip, 'Delete License Activation']
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("div", null, [
                          _createVNode(_component_Button, {
                            type: "button",
                            icon: "pi pi-file-export",
                            onClick: ($event: any) => (_ctx.exportLicenseActivationsFromGrid(data)),
                            class: "p-button-rounded p-button-outlined p-button-secondary"
                          }, null, 8, ["onClick"])
                        ])), [
                          [_directive_tooltip, 'Export License Activation']
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "activationState",
                    header: "State",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.activationState), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_MultiSelect, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        options: _ctx.activationStateOptions,
                        placeholder: "Any",
                        showClear: true,
                        maxSelectedLabels: 1,
                        onChange: ($event: any) => (filterCallback())
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "activationInfo.computerName",
                    header: "Computer Name",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.activationInfo.computerName), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "activationInfo.userDomainName",
                    header: "User Domain Name",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.activationInfo.userDomainName), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "activationInfo.userName",
                    header: "User Name",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.activationInfo.userName), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "activationInfo.productVersion",
                    header: "Product Version",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.activationInfo.productVersion), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "activationInfo.hostVersion",
                    header: "Host Version",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.activationInfo.hostVersion), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "activationInfo.osVersion",
                    header: "OS Version",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.activationInfo.osVersion), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "endpoint",
                    header: "EndPoint",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.endpoint), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "createTime",
                    header: "Create Time",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.createTime.toDateString()), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_Calendar, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        selectionMode: "range",
                        manualInput: false,
                        placeholder: "From – To",
                        showButtonBar: true,
                        onHide: ($event: any) => (filterCallback()),
                        onClearClick: ($event: any) => (filterCallback())
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onHide", "onClearClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "modifiedTime",
                    header: "Modified Time",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.modifiedTime.toDateString()), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_Calendar, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        selectionMode: "range",
                        manualInput: false,
                        placeholder: "From – To",
                        showButtonBar: true,
                        onHide: ($event: any) => (filterCallback()),
                        onClearClick: ($event: any) => (filterCallback())
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onHide", "onClearClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, [
                (!_ctx.loading)
                  ? {
                      name: "empty",
                      fn: _withCtx(() => [
                        (!_ctx.selectedAccount)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Select Account and License from dropdowns to display Activations."))
                          : (_openBlock(), _createElementBlock("div", _hoisted_16, "The selected account does not have any activations."))
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["selection", "value", "rows", "totalRecords", "filters", "loading", "globalFilterFields"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressSpinner, { key: 1 }))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
        (!_ctx.showModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(_component_DataTable, {
                class: "activations-datatable",
                scrollHeight: "flex",
                stripedRows: "",
                dataKey: "autoId",
                selectionMode: "single",
                currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                rowsPerPageOptions: [10, 25, 50, 100],
                selection: _ctx.selectedActivation,
                "onUpdate:selection": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedActivation) = $event)),
                scrollable: true,
                value: _ctx.items,
                paginator: true,
                rows: _ctx.rows,
                totalRecords: _ctx.totalRecords,
                filters: _ctx.filters,
                "onUpdate:filters": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters) = $event)),
                loading: _ctx.loading,
                globalFilterFields: _ctx.globalFilter,
                filterDisplay: "row"
              }, _createSlots({
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("span", _hoisted_23, [
                          _hoisted_24,
                          _createVNode(_component_InputText, {
                            modelValue: _ctx.filters['global'].value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
                            placeholder: "Keyword Search"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      (_ctx.selectedActivation && _ctx.selectedActivation.autoId)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("div", null, [
                              _createVNode(_component_Button, {
                                label: "Delete Activation",
                                class: "p-button-danger p-button-outlined",
                                onClick: _ctx.deleteLicenseActivation
                              }, null, 8, ["onClick"]),
                              _createVNode(_component_ConfirmPopup)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.totalRecords > 0 && !_ctx.accountStore.isCustomer)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_Button, {
                                label: "Export",
                                class: "p-button-secondary p-button-outlined",
                                onClick: _ctx.exportLicenseActivations
                              }, null, 8, ["onClick"])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _createVNode(_component_Button, {
                                label: "Export",
                                class: "p-button-secondary p-button-outlined",
                                onClick: _ctx.exportClientLicenseActivations
                              }, null, 8, ["onClick"])
                            ])
                          ]))
                    ])
                  ])
                ]),
                loading: _withCtx(() => [
                  _createTextVNode("Loading licenses. Please wait.")
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    header: "Actions",
                    headerStyle: "padding-left: 18px;",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("div", _hoisted_33, [
                        _withDirectives((_openBlock(), _createElementBlock("div", null, [
                          _createVNode(_component_Button, {
                            type: "button",
                            icon: "pi pi-trash",
                            onClick: ($event: any) => (_ctx.deleteActivationFromGrid(data, $event)),
                            class: "p-button-rounded p-button-outlined p-button-danger"
                          }, null, 8, ["onClick"])
                        ])), [
                          [_directive_tooltip, 'Delete License Activation']
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("div", null, [
                          _createVNode(_component_Button, {
                            type: "button",
                            icon: "pi pi-file-export",
                            onClick: ($event: any) => (_ctx.exportLicenseActivationsFromGrid(data)),
                            class: "p-button-rounded p-button-outlined p-button-secondary"
                          }, null, 8, ["onClick"])
                        ])), [
                          [_directive_tooltip, 'Export License Activation']
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "activationState",
                    header: "State",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.activationState), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_MultiSelect, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        options: _ctx.activationStateOptions,
                        placeholder: "Any",
                        showClear: true,
                        maxSelectedLabels: 1,
                        onChange: ($event: any) => (filterCallback())
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "activationInfo.computerName",
                    header: "Computer Name",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.activationInfo.computerName), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "activationInfo.userDomainName",
                    header: "User Domain Name",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.activationInfo.userDomainName), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "activationInfo.userName",
                    header: "User Name",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.activationInfo.userName), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "activationInfo.productVersion",
                    header: "Product Version",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.activationInfo.productVersion), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "activationInfo.hostVersion",
                    header: "Host Version",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.activationInfo.hostVersion), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "activationInfo.osVersion",
                    header: "OS Version",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.activationInfo.osVersion), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "endpoint",
                    header: "EndPoint",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.endpoint), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "createTime",
                    header: "Create Time",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.createTime.toDateString()), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_Calendar, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        selectionMode: "range",
                        manualInput: false,
                        placeholder: "From – To",
                        showButtonBar: true,
                        onHide: ($event: any) => (filterCallback()),
                        onClearClick: ($event: any) => (filterCallback())
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onHide", "onClearClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "modifiedTime",
                    header: "Modified Time",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.modifiedTime.toDateString()), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_Calendar, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        selectionMode: "range",
                        manualInput: false,
                        placeholder: "From – To",
                        showButtonBar: true,
                        onHide: ($event: any) => (filterCallback()),
                        onClearClick: ($event: any) => (filterCallback())
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onHide", "onClearClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, [
                (!_ctx.loading)
                  ? {
                      name: "empty",
                      fn: _withCtx(() => [
                        (!_ctx.selectedAccount)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, "Select Account and License from dropdowns to display Activations."))
                          : (_openBlock(), _createElementBlock("div", _hoisted_32, "The selected account does not have any activations."))
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["selection", "value", "rows", "totalRecords", "filters", "loading", "globalFilterFields"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressSpinner, { key: 1 }))
          : _createCommentVNode("", true)
      ]))
}